"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var FormControlLabel_1 = require("@material-ui/core/FormControlLabel/FormControlLabel");

var Typography_1 = require("@material-ui/core/Typography/Typography");

var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");

var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");

var React = require("react");

var config_1 = require("../../config");

var withStyles_1 = require("../../decorators/withStyles");

var FieldSelectionBase =
/** @class */
function (_super) {
  tslib_1.__extends(FieldSelectionBase, _super);

  function FieldSelectionBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (event) {
      var value = _this.props.value;

      if ((event || {}).target && event.target.type === 'checkbox') {
        value = _this.props.value ? event.target.checked ? _this.props.value : null : event.target.checked;
      }

      config_1.getConfig().validationOn === 'onChange' && _this.setState({
        showError: true
      });

      _this.props.onChange(value, event);
    };

    _this.onBlur = function () {
      config_1.getConfig().validationOn === 'onBlur' && _this.setState({
        showError: true
      });
    };

    return _this;
  }

  Object.defineProperty(FieldSelectionBase.prototype, "labelClassName", {
    get: function get() {
      var _a = this.props,
          helperText = _a.helperText,
          disableLabelMargin = _a.disableLabelMargin,
          classes = _a.classes,
          FormControlLabelProps = _a.FormControlLabelProps;
      return (helperText && !disableLabelMargin ? classes.labelAlign : '') + ' ' + (FormControlLabelProps && FormControlLabelProps.labelPlacement === 'start' ? classes.labelRight : '');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FieldSelectionBase.prototype, "helperTextClassName", {
    get: function get() {
      var _a = this.props,
          FormControlLabelProps = _a.FormControlLabelProps,
          classes = _a.classes;
      return classes.helperText + ' ' + (FormControlLabelProps && FormControlLabelProps.labelPlacement === 'start' ? classes.labelRight : '');
    },
    enumerable: true,
    configurable: true
  });

  FieldSelectionBase.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        label = _a.label,
        checked = _a.checked,
        helperText = _a.helperText,
        classes = _a.classes,
        disabled = _a.disabled,
        Component = _a.Component,
        FormControlLabelProps = _a.FormControlLabelProps;
    return React.createElement(React.Fragment, null, React.createElement(ValidationContextRegister_1.default, {
      field: this
    }), React.createElement(FormControlLabel_1.default, tslib_1.__assign({}, FormControlLabelProps || {}, {
      className: helperText ? classes.containerAlign : null,
      control: checked ? //force recreation
      React.createElement(Component, {
        checked: true,
        disabled: disabled,
        onChange: this.onChange,
        onBlur: this.onBlur,
        value: (value || '').toString()
      }) : React.createElement(Component, {
        checked: false,
        disabled: disabled,
        onChange: this.onChange,
        onBlur: this.onBlur,
        value: (value || '').toString()
      }),
      label: React.createElement(React.Fragment, null, !!label && React.createElement(React.Fragment, null, React.createElement(Typography_1.default, {
        className: this.labelClassName
      }, label), !!helperText && React.createElement(Typography_1.default, {
        className: this.helperTextClassName
      }, helperText)), this.props.children)
    })));
  };

  FieldSelectionBase = tslib_1.__decorate([withStyles_1.WithStyles({
    containerAlign: {
      alignItems: 'flex-start'
    },
    labelAlign: {
      marginTop: 14
    },
    labelRight: {
      textAlign: 'right'
    },
    helperText: {
      opacity: 0.7,
      fontSize: '95%'
    }
  })], FieldSelectionBase);
  return FieldSelectionBase;
}(FieldCoreBase_1.default);

exports.default = FieldSelectionBase;